import { render, staticRenderFns } from "./SfHeaderNavigationItem.vue?vue&type=template&id=3addb0fd&"
import script from "./SfHeaderNavigationItem.vue?vue&type=script&lang=js&"
export * from "./SfHeaderNavigationItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports